import { render, staticRenderFns } from "./AdPage.vue?vue&type=template&id=2fba790e&scoped=true&"
import script from "./AdPage.vue?vue&type=script&lang=js&"
export * from "./AdPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba790e",
  null
  
)

export default component.exports